import {
  type DependencyList,
  type EffectCallback,
  useEffect,
  useRef,
} from 'react';

// Creates a useEffect hook that doesn't run on compnent mount
export const useEffectAfterMount = (
  cb: EffectCallback,
  dependencies: DependencyList | undefined = []
) => {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) {
      return cb();
    }
    mounted.current = true;
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps
};
